var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 53,
    viewBox: "0 0 179 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.02273C0 2.69647 2.69647 0 6.02273 0H172.852C176.179 0 178.875 2.69647 178.875 6.02273V46.9773C178.875 50.3035 176.179 53 172.852 53H6.02272C2.69646 53 0 50.3035 0 46.9773V6.02273Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2802 28.8204C87.1638 28.8204 84.6238 31.1909 84.6238 34.4557C84.6238 37.7006 87.1638 40.0909 90.2802 40.0909C93.3979 40.0909 95.9379 37.7006 95.9379 34.4557C95.9366 31.1909 93.3966 28.8204 90.2802 28.8204ZM90.2802 37.8728C88.5723 37.8728 87.1002 36.4644 87.1002 34.457C87.1002 32.4284 88.5736 31.0411 90.2802 31.0411C91.9881 31.0411 93.4602 32.4284 93.4602 34.457C93.4602 36.463 91.9881 37.8728 90.2802 37.8728ZM77.9391 28.8204C74.8227 28.8204 72.2827 31.1909 72.2827 34.4557C72.2827 37.7006 74.8227 40.0909 77.9391 40.0909C81.0569 40.0909 83.5969 37.7006 83.5969 34.4557C83.5969 31.1909 81.0569 28.8204 77.9391 28.8204ZM77.9391 37.8728C76.2312 37.8728 74.7591 36.4644 74.7591 34.457C74.7591 32.4284 76.2325 31.0411 77.9391 31.0411C79.6471 31.0411 81.1191 32.4284 81.1191 34.457C81.1205 36.463 79.6471 37.8728 77.9391 37.8728ZM63.2608 30.5509V32.9412H68.9821C68.8112 34.2861 68.3634 35.2679 67.6797 35.9503C66.8476 36.7824 65.5451 37.7006 63.2608 37.7006C59.7389 37.7006 56.9856 34.8611 56.9856 31.3393C56.9856 27.8174 59.7389 24.9779 63.2608 24.9779C65.1608 24.9779 66.5481 25.7252 67.5723 26.6859L69.2591 24.9991C67.8281 23.6331 65.9293 22.5876 63.2608 22.5876C58.4365 22.5876 54.3806 26.5149 54.3806 31.3393C54.3806 36.1636 58.4365 40.0909 63.2608 40.0909C65.8644 40.0909 67.8294 39.2363 69.3651 37.6357C70.9445 36.0563 71.436 33.8356 71.436 32.0428C71.436 31.489 71.3936 30.9762 71.3075 30.5496H63.2608V30.5509ZM123.294 32.4072C122.825 31.1485 121.394 28.8204 118.47 28.8204C115.567 28.8204 113.154 31.1047 113.154 34.4557C113.154 37.6145 115.545 40.0909 118.747 40.0909C121.329 40.0909 122.824 38.5115 123.444 37.5933L121.522 36.312C120.882 37.2514 120.007 37.8702 118.747 37.8702C117.488 37.8702 116.591 37.2938 116.014 36.1623L123.55 33.0459L123.294 32.4072ZM115.609 34.2861C115.545 32.1078 117.296 30.9987 118.556 30.9987C119.538 30.9987 120.37 31.4903 120.648 32.1939L115.609 34.2861ZM109.483 39.7504H111.959V23.1865H109.483V39.7504ZM105.426 30.0805H105.341C104.786 29.418 103.718 28.8204 102.375 28.8204C99.5565 28.8204 96.9741 31.2969 96.9741 34.4782C96.9741 37.637 99.5565 40.0922 102.375 40.0922C103.72 40.0922 104.786 39.4946 105.341 38.8123H105.426V39.6232C105.426 41.7789 104.274 42.9317 102.417 42.9317C100.901 42.9317 99.962 41.8439 99.5777 40.9256L97.4219 41.8227C98.0407 43.3159 99.6837 45.1524 102.417 45.1524C105.32 45.1524 107.775 43.4445 107.775 39.2813V29.1636H105.428V30.0805H105.426ZM102.588 37.8728C100.88 37.8728 99.4505 36.4418 99.4505 34.4782C99.4505 32.492 100.88 31.0411 102.588 31.0411C104.274 31.0411 105.597 32.492 105.597 34.4782C105.597 36.4418 104.274 37.8728 102.588 37.8728ZM134.893 23.1865H128.969V39.7504H131.44V33.4752H134.892C137.632 33.4752 140.327 31.4916 140.327 28.3315C140.327 25.1714 137.633 23.1865 134.893 23.1865ZM134.957 31.1697H131.44V25.492H134.957C136.805 25.492 137.854 27.0224 137.854 28.3315C137.854 29.6141 136.805 31.1697 134.957 31.1697ZM150.236 28.7913C148.446 28.7913 146.593 29.5797 145.826 31.3273L148.02 32.2429C148.489 31.3273 149.363 31.0279 150.279 31.0279C151.557 31.0279 152.857 31.7951 152.878 33.1585V33.3294C152.431 33.0737 151.471 32.6908 150.3 32.6908C147.935 32.6908 145.526 33.9906 145.526 36.4193C145.526 38.636 147.466 40.0631 149.639 40.0631C151.3 40.0631 152.217 39.3171 152.792 38.4426H152.877V39.7212H155.265V33.3705C155.266 30.4316 153.069 28.7913 150.236 28.7913ZM149.937 37.8689C149.129 37.8689 147.999 37.4634 147.999 36.4617C147.999 35.1831 149.406 34.6928 150.621 34.6928C151.706 34.6928 152.219 34.9274 152.878 35.2467C152.686 36.7824 151.365 37.8689 149.937 37.8689ZM163.959 29.153L161.125 36.3345H161.04L158.099 29.153H155.436L159.847 39.1899L157.332 44.7734H159.91L166.709 29.153H163.959ZM141.692 39.7504H144.163V23.1865H141.692V39.7504Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8289 13.572C62.8289 14.6823 62.5003 15.5661 61.8418 16.226C61.0945 17.0104 60.1193 17.4026 58.9215 17.4026C57.774 17.4026 56.7975 17.0051 55.9959 16.2101C55.1929 15.4137 54.7915 14.4279 54.7915 13.2513C54.7915 12.0734 55.1929 11.0876 55.9959 10.2926C56.7975 9.49628 57.774 9.09878 58.9215 9.09878C59.4912 9.09878 60.0358 9.21008 60.5526 9.43135C61.0706 9.65395 61.4854 9.94943 61.7954 10.3191L61.0971 11.0187C60.5711 10.3893 59.8463 10.0753 58.9202 10.0753C58.0828 10.0753 57.3593 10.3695 56.7485 10.9578C56.1377 11.5461 55.8329 12.3106 55.8329 13.25C55.8329 14.1894 56.1377 14.954 56.7485 15.5423C57.3593 16.1306 58.0828 16.4247 58.9202 16.4247C59.8079 16.4247 60.5486 16.1292 61.1409 15.537C61.5251 15.1514 61.7477 14.6148 61.8073 13.9271H58.9202V12.9718H62.7719C62.8117 13.1798 62.8289 13.3799 62.8289 13.572Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9373 10.2516H65.3174V12.7718H68.5822V13.7271H65.3174V16.2472H68.9373V17.2251H64.2958V9.27508H68.9373V10.2516Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2447 17.2251H72.2232V10.2516H70.0024V9.27508H75.4654V10.2516H73.2447V17.2251Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4178 17.2251V9.27508H80.4394V17.2251H79.4178Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9698 17.2251H83.9482V10.2516H81.7275V9.27508H87.1905V10.2516H84.9698V17.2251Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5318 16.1982C96.7501 17.0011 95.7789 17.4026 94.6168 17.4026C93.4548 17.4026 92.4836 17.0011 91.7032 16.1982C90.9214 15.3952 90.5319 14.4121 90.5319 13.2501C90.5319 12.088 90.9214 11.1049 91.7032 10.3019C92.4836 9.49899 93.4548 9.09619 94.6168 9.09619C95.7722 9.09619 96.7421 9.50032 97.5265 10.3072C98.3109 11.1142 98.7031 12.0947 98.7031 13.2501C98.7031 14.4121 98.3123 15.3952 97.5318 16.1982ZM92.4571 15.5317C93.0454 16.128 93.7649 16.4248 94.6168 16.4248C95.4688 16.4248 96.1896 16.1266 96.7766 15.5317C97.3649 14.9355 97.6604 14.1749 97.6604 13.2501C97.6604 12.3252 97.3649 11.5647 96.7766 10.9684C96.1896 10.3722 95.4688 10.0754 94.6168 10.0754C93.7649 10.0754 93.0454 10.3735 92.4571 10.9684C91.8701 11.5647 91.5746 12.3252 91.5746 13.2501C91.5746 14.1749 91.8701 14.9355 92.4571 15.5317Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.137 17.2251V9.27508H101.38L105.243 15.4589H105.287L105.243 13.9272V9.27508H106.265V17.2251H105.198L101.156 10.7405H101.112L101.156 12.2722V17.2251H100.137Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8289 13.572C62.8289 14.6823 62.5003 15.5661 61.8418 16.226C61.0945 17.0104 60.1193 17.4026 58.9215 17.4026C57.774 17.4026 56.7975 17.0051 55.9959 16.2101C55.1929 15.4137 54.7915 14.4279 54.7915 13.2513C54.7915 12.0734 55.1929 11.0876 55.9959 10.2926C56.7975 9.49628 57.774 9.09878 58.9215 9.09878C59.4912 9.09878 60.0358 9.21008 60.5526 9.43135C61.0706 9.65395 61.4854 9.94943 61.7954 10.3191L61.0971 11.0187C60.5711 10.3893 59.8463 10.0753 58.9202 10.0753C58.0828 10.0753 57.3593 10.3695 56.7485 10.9578C56.1377 11.5461 55.8329 12.3106 55.8329 13.25C55.8329 14.1894 56.1377 14.954 56.7485 15.5423C57.3593 16.1306 58.0828 16.4247 58.9202 16.4247C59.8079 16.4247 60.5486 16.1292 61.1409 15.537C61.5251 15.1514 61.7477 14.6148 61.8073 13.9271H58.9202V12.9718H62.7719C62.8117 13.1798 62.8289 13.3799 62.8289 13.572Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9373 10.2516H65.3174V12.7718H68.5822V13.7271H65.3174V16.2472H68.9373V17.2251H64.2958V9.27508H68.9373V10.2516Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2447 17.2251H72.2232V10.2516H70.0024V9.27508H75.4654V10.2516H73.2447V17.2251Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4178 17.2251V9.27508H80.4394V17.2251H79.4178Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9698 17.2251H83.9482V10.2516H81.7275V9.27508H87.1905V10.2516H84.9698V17.2251Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5318 16.1982C96.7501 17.0011 95.7789 17.4026 94.6168 17.4026C93.4548 17.4026 92.4836 17.0011 91.7032 16.1982C90.9214 15.3952 90.5319 14.4121 90.5319 13.2501C90.5319 12.088 90.9214 11.1049 91.7032 10.3019C92.4836 9.49899 93.4548 9.09619 94.6168 9.09619C95.7722 9.09619 96.7421 9.50032 97.5265 10.3072C98.3109 11.1142 98.7031 12.0947 98.7031 13.2501C98.7031 14.4121 98.3123 15.3952 97.5318 16.1982ZM92.4571 15.5317C93.0454 16.128 93.7649 16.4248 94.6168 16.4248C95.4688 16.4248 96.1896 16.1266 96.7766 15.5317C97.3649 14.9355 97.6604 14.1749 97.6604 13.2501C97.6604 12.3252 97.3649 11.5647 96.7766 10.9684C96.1896 10.3722 95.4688 10.0754 94.6168 10.0754C93.7649 10.0754 93.0454 10.3735 92.4571 10.9684C91.8701 11.5647 91.5746 12.3252 91.5746 13.2501C91.5746 14.1749 91.8701 14.9355 92.4571 15.5317Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.137 17.2251V9.27508H101.38L105.243 15.4589H105.287L105.243 13.9272V9.27508H106.265V17.2251H105.198L101.156 10.7405H101.112L101.156 12.2722V17.2251H100.137Z",
    stroke: "white",
    strokeWidth: 0.240909,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8277 9.98784C13.4421 10.3959 13.2142 11.0293 13.2142 11.8495V41.1532C13.2142 41.9747 13.4421 42.6067 13.8277 43.0148L13.9257 43.1102L30.3412 26.6948V26.5013V26.3079L13.9257 9.89111L13.8277 9.98784Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8121 32.1682L30.3412 26.6946V26.5011V26.3077L35.8134 20.8354L35.9366 20.9057L42.4199 24.5892C44.2709 25.6412 44.2709 27.3624 42.4199 28.4158L35.9366 32.0993L35.8121 32.1682Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.9366 32.098L30.3398 26.5012L13.8277 43.0147C14.4372 43.6613 15.4455 43.7408 16.581 43.0968L35.9366 32.098Z",
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.9366 20.9045L16.581 9.90697C15.4455 9.26169 14.4372 9.34252 13.8277 9.98912L30.3412 26.5026L35.9366 20.9045Z",
    fill: "url(#paint3_linear)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02273 1.20455H172.852V-1.20455H6.02273V1.20455ZM177.67 6.02273V46.9773H180.08V6.02273H177.67ZM172.852 51.7955H6.02272V54.2045H172.852V51.7955ZM1.20455 46.9773V6.02273H-1.20455V46.9773H1.20455ZM6.02272 51.7955C3.36172 51.7955 1.20455 49.6383 1.20455 46.9773H-1.20455C-1.20455 50.9688 2.03121 54.2045 6.02272 54.2045V51.7955ZM177.67 46.9773C177.67 49.6383 175.513 51.7955 172.852 51.7955V54.2045C176.844 54.2045 180.08 50.9688 180.08 46.9773H177.67ZM172.852 1.20455C175.513 1.20455 177.67 3.36172 177.67 6.02273H180.08C180.08 2.03122 176.844 -1.20455 172.852 -1.20455V1.20455ZM6.02273 -1.20455C2.03121 -1.20455 -1.20455 2.03122 -1.20455 6.02273H1.20455C1.20455 3.36172 3.36172 1.20455 6.02273 1.20455V-1.20455Z",
    fill: "#A6A6A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii",
    x: 13.2142,
    y: 9.46167,
    width: 30.5939,
    height: 34.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.180682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.180682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 13.8277,
    y: 26.5012,
    width: 22.1089,
    height: 17.0404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.180682
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.8861,
    y1: 11.5394,
    x2: 6.6499,
    y2: 33.7756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 44.8294,
    y1: 26.5012,
    x2: 12.7698,
    y2: 26.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 32.8972,
    y1: 29.5406,
    x2: 2.74222,
    y2: 59.6957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.66905,
    y1: 0.234204,
    x2: 23.1341,
    y2: 13.6993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGoogle);
export default __webpack_public_path__ + "static/media/downloadGoogle.606cf71bb1288a74df7f9bad896758bf.svg";
export { ForwardRef as ReactComponent };